/**
 * created by mleitzell on 4/4/18.
 * Tag names for different element types
 */
import locale from "common/managers/locale";

export default {

    PARAGRAPH: "PARAGRAPH",
    HEADING_1: "HEADING_1",
    HEADING_2: "HEADING_2",
    HEADING_3: "HEADING_3",
    HEADING_4: "HEADING_4",

    nodeName: function(type) {
        switch (type) {
            case this.PARAGRAPH:
                return "p";
            case this.HEADING_1:
                return "h1";
            case this.HEADING_2:
                return "h2";
            case this.HEADING_3:
                return "h3";
            case this.HEADING_4:
                return "h4";
            default:
                return "";
        }
    },

    refName: function(type) {
        switch (type) {
            case this.PARAGRAPH:
                return "PARAGRAPH";
            case this.HEADING_1:
                return "HEADING_1";
            case this.HEADING_2:
                return "HEADING_2";
            case this.HEADING_3:
                return "HEADING_3";
            case this.HEADING_4:
                return "HEADING_4";
            default:
                return "";
        }
    },

    displayName: function(type) {
        switch (type) {
            case this.PARAGRAPH:
                return locale.get("paragraph");
            case this.HEADING_1:
                return locale.get("heading.1");
            case this.HEADING_2:
                return locale.get("heading.2");
            case this.HEADING_3:
                return locale.get("heading.3");
            case this.HEADING_4:
                return locale.get("heading.4");
            default:
                return "";
        }
    },

    styleName: function(type) {
        switch (type) {
            case this.PARAGRAPH:
                return "paragraph";
            case this.HEADING_1:
                return "heading1";
            case this.HEADING_2:
                return "heading2";
            case this.HEADING_3:
                return "heading3";
            case this.HEADING_4:
                return "heading4";
            default:
                return "";
        }
    }
};
